// ============================================================
// TetrixWMS Menu — Restructured UX 2026
// Grouped accordion menu with logical WMS workflow sections
// ============================================================

const Home = {
  text: 'Home',
  translate: 'menu.home',
  link: '/home',
  icon: 'fas fa-home',
};

// --- WAREHOUSE (Magazzino) ---
// Groups: Locations, Zones, Stock visibility
const Warehouse = {
  text: 'Warehouse',
  translate: 'menu.warehouse',
  icon: 'fas fa-warehouse',
  submenu: [
    {
      text: 'Location',
      translate: 'menu.location',
      link: '/location',
      icon: 'fas fa-map-marker-alt',
    },
    {
      text: 'Zone',
      translate: 'menu.zone',
      link: '/zone',
      icon: 'fas fa-th-large',
    },
    {
      text: 'UdmStock',
      translate: 'menu.product_stock',
      link: '/udm-stock',
      icon: 'fas fa-boxes',
    },
  ],
};

// --- INBOUND (Ricevimento) ---
// Full receiving flow: docks → DDT → orders → receiving → QC → putaway
const Inbound = {
  text: 'Ricevimento',
  translate: 'menu.header_inbound',
  icon: 'fas fa-sign-in-alt',
  submenu: [
    {
      text: 'Dock',
      translate: 'menu.dock',
      link: '/docks',
      icon: 'fas fa-warehouse',
    },
    {
      text: 'Ddt',
      translate: 'menu.ddt',
      link: '/ddt',
      icon: 'fas fa-file-invoice',
    },
    {
      text: 'Order',
      translate: 'menu.order_list',
      link: '/orders',
      icon: 'fas fa-clipboard-list',
    },
    {
      text: 'ProductOrder',
      translate: 'menu.product_order',
      link: '/product-order',
      icon: 'fas fa-receipt',
    },
    {
      text: 'Receiving',
      translate: 'menu.receiving',
      link: '/receiving',
      icon: 'fas fa-people-carry',
    },
  ],
};

// --- QUALITY CONTROL ---
const QualityControl = {
  text: 'QualityControl',
  translate: 'menu.header_quality_control',
  icon: 'fas fa-clipboard-check',
  submenu: [
    {
      text: 'SurveyTemplates',
      translate: 'menu.survey_templates',
      link: '/survey-templates',
      icon: 'fas fa-clipboard-check',
    },
    {
      text: 'QCChecks',
      translate: 'menu.qc_checks',
      link: '/qc-checks',
      icon: 'fas fa-check-circle',
    },
  ],
};

// --- PUTAWAY (Stoccaggio) ---
const Putaway = {
  text: 'Putaway',
  translate: 'menu.header_putaway',
  icon: 'fas fa-dolly',
  submenu: [
    {
      text: 'PutawayUdms',
      translate: 'menu.putaway_udms',
      link: '/putaway-udms',
      icon: 'fas fa-pallet',
    },
    {
      text: 'PutawayRules',
      translate: 'menu.putaway_rules',
      link: '/putaway-rules',
      icon: 'fas fa-balance-scale',
    },
    {
      text: 'PutawayMissions',
      translate: 'menu.putaway_missions',
      link: '/putaway-missions',
      icon: 'fas fa-rocket',
    },
  ],
};

// --- OUTBOUND (Spedizioni) ---
const Outbound = {
  text: 'Outbound',
  translate: 'menu.header_shipping',
  icon: 'fas fa-shipping-fast',
  submenu: [
    {
      text: 'SaleOrders',
      translate: 'menu.sale_orders',
      link: '/sale-orders',
      icon: 'fas fa-money-check-alt',
    },
    {
      text: 'PickingCheck',
      translate: 'menu.picking_check',
      link: '/picking-check',
      icon: 'fas fa-search',
    },
  ],
};

// --- PROCESSING (Lavorazioni) ---
const Processing = {
  text: 'Processing',
  translate: 'menu.header_processing',
  icon: 'fas fa-cogs',
  submenu: [
    {
      text: 'ProcessingOrders',
      translate: 'menu.processing_orders',
      link: '/processing-orders',
      icon: 'fas fa-tape',
    },
    {
      text: 'ProcessingCheck',
      translate: 'menu.processing_check',
      link: '/processing-check',
      icon: 'fas fa-search',
    },
    {
      text: 'ProcessingThreshold',
      translate: 'menu.processing_threshold',
      link: '/processing-threshold',
      icon: 'fas fa-sliders-h',
    },
  ],
};

// --- PRODUCTS & REGISTRY (Anagrafiche) ---
const Registries = {
  text: 'Registries',
  translate: 'menu.registry',
  icon: 'fas fa-database',
  submenu: [
    {
      text: 'Products',
      translate: 'menu.products',
      icon: 'fas fa-box',
      submenu: [
        {
          text: 'Thresholds',
          translate: 'menu.thresholds',
          link: '/products/thresholds',
          icon: 'fas fa-clock',
        },
        {
          text: 'TipologyCustomers',
          translate: 'menu.typology_customers',
          link: '/products/typology-customers',
          icon: 'fas fa-angle-right',
        },
      ],
    },
    {
      text: 'Vendor',
      translate: 'menu.vendors',
      link: '/registry/vendors',
      icon: 'fas fa-truck',
    },
    {
      text: 'Customer',
      translate: 'menu.customers',
      link: '/registry/customers',
      icon: 'fas fa-store',
    },
    {
      text: 'Item',
      translate: 'menu.items',
      icon: 'fas fa-boxes',
      submenu: [
        {
          text: 'Calibre',
          translate: 'menu.calibre',
          link: '/registry/items/calibre',
          icon: 'fas fa-angle-right',
        },
        {
          text: 'Origin',
          translate: 'menu.origin',
          link: '/registry/items/origin',
          icon: 'fas fa-angle-right',
        },
        {
          text: 'Quality',
          translate: 'menu.quality',
          link: '/registry/items/quality',
          icon: 'fas fa-angle-right',
        },
        {
          text: 'Dimension',
          translate: 'menu.size',
          link: '/registry/items/size',
          icon: 'fas fa-angle-right',
        },
        {
          text: 'Specie',
          translate: 'menu.specie',
          link: '/registry/items/specie',
          icon: 'fas fa-angle-right',
        },
        {
          text: 'Variety',
          translate: 'menu.variety',
          link: '/registry/items/variety',
          icon: 'fas fa-angle-right',
        },
        {
          text: 'Typology',
          translate: 'menu.typology',
          link: '/registry/items/typology',
          icon: 'fas fa-angle-right',
        },
        {
          text: 'Processing',
          translate: 'menu.processing',
          link: '/registry/items/processing',
          icon: 'fas fa-angle-right',
        },
        {
          text: 'Platform',
          translate: 'menu.platform',
          link: '/registry/items/platform',
          icon: 'fas fa-angle-right',
        },
      ],
    },
    {
      text: 'Processing types',
      translate: 'menu.processing_types',
      link: '/registry/processing-types',
      icon: 'fas fa-box-open',
    },
  ],
};

// --- ADMIN & SETTINGS ---
const Admin = {
  text: 'Admin',
  translate: 'menu.admin',
  icon: 'fas fa-sliders-h',
  submenu: [
    {
      text: 'User',
      translate: 'menu.user',
      link: '/user',
      icon: 'fas fa-users',
    },
    {
      text: 'Printers',
      translate: 'menu.printers',
      link: '/printers',
      icon: 'fas fa-print',
    },
    {
      text: 'Report',
      translate: 'menu.report',
      link: '/report',
      icon: 'fas fa-chart-bar',
    },
    {
      text: 'Setting',
      translate: 'menu.settings',
      icon: 'fas fa-cog',
      submenu: [
        {
          text: 'Service queue',
          translate: 'menu.service_queue',
          link: '/settings/service-queue',
          icon: 'fas fa-stream',
        },
        {
          text: 'Causal',
          translate: 'menu.causal',
          link: '/settings/causal',
          icon: 'fas fa-comment-dots',
        },
        {
          text: 'Purpose',
          translate: 'menu.purpose',
          link: '/settings/purpose',
          icon: 'fas fa-location-arrow',
        },
        {
          text: 'Mailing list',
          translate: 'menu.mailing_list',
          link: '/settings/mailing-list',
          icon: 'fas fa-envelope',
        },
        {
          text: 'Api call log',
          translate: 'menu.api_call_log',
          link: '/settings/api-call-log',
          icon: 'fas fa-stream',
        },
      ],
    },
  ],
};

// ============================================================
// MENU EXPORT — Logical WMS workflow order
// Home → Warehouse → Inbound → QC → Putaway → Outbound → Processing → Registries → Admin
// ============================================================
export const menu = [
  Home,
  Warehouse,
  Inbound,
  QualityControl,
  Putaway,
  Outbound,
  Processing,
  Registries,
  Admin,
];
